import { createClient, gql } from 'urql'
import { RequestLevel } from '../constants'
import { gqlClientOptions } from './base'
import { Query, StoredPaymentMethod } from './generated-types/custom-graphql'

export type { StoredPaymentMethod }

export const STORED_PAYMENT_METHODS_QUERY = gql<Query>(`
  query StoredPaymentMethods(
    $where: StoredPaymentMethodWhereInput
    $orderBy: [StoredPaymentMethodOrderByInput!]
  ) {
    storedPaymentMethods(where: $where, orderBy: $orderBy) {
      id
      customerId
      cardName
      cardBrand
      cardLast4
      cardType
      expiresMonth
      expiresYear
      postalCode
			city
			state
			addressLine1
			addressLine2
			country
      readMethod
      createdAt
      hasAcknowledgement
      acknowledgementMode
      acknowledgedAt
      signatureStatus
      signatureUrl
    }
  }
`)

export const getStoredPaymentMethodsGql = (practiceId: string, customerId: string) => {
	const graphQLClient = createClient(
		gqlClientOptions({ practiceId, requestLevel: RequestLevel.PRACTICE })
	)
	return graphQLClient
		.query<{
			storedPaymentMethods: StoredPaymentMethod[]
		}>(STORED_PAYMENT_METHODS_QUERY, { where: { customerId: { equals: customerId } } })
		.toPromise()
}
